import gql from 'graphql-tag';

export const GET_INDIVIDUAL_AGENT_SERVICES = gql`
	query GetIndividualAgentServices($query: JSON!, $limit: Int, $offset: Int, $order: [[String]]) {
		services(query: $query, limit: $limit, offset: $offset, order: $order) {
			id
			status
			type
			serviceDate
			timezone
			client {
				id
			}
			bookedOptions {
				id
				name
				quantity
				additionalInfoType
			}
			photographer {
				id
				image
				name
			}
			property {
				id
				alias
				streetAddress
				city
				state
			}
		}
	}
`;
